import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { FormTextAreaField } from "../../components/form/text-area";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../config";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import ResetPasswordModal from "../../components/modal/reset-password-modal";
import backArrow from "../../assets/icons/back-arrow.svg";
import { FormDocumentField } from "../../components/form/document-upload";
import { FormDropDown } from "../../components/form/dropdown";
import Editor from "../../components/editor";
import FAQManager from "../../components/editor/components/FAQManager";
import { FormImageField } from "../../components/form/image";
import FormSlugTextField from "../../components/form/slug-input";

const EditBlogs = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [contentData, setContentData] = useState([]);
  const [slugStatus, setSlugStatus] = useState("");

  const checkSlugApi = async (value, form) => {
    try {
      const res = await axios.post(`${url}/slug/blog-slug-check`, {
        slug: value,
      });

      if (res?.data?.data?.available) {
        setSlugStatus("available");

        form.setFieldValue("slugStatus", "available");
        form.setFieldError("slug", "");

        // revalidate
        form.validateField("slug");
      } else {
        setSlugStatus("exists");

        form.setFieldValue("slugStatus", "exists");
        form.setFieldError("slug", "Slug already exists");
        form.setFieldTouched("slug", true, false);

        // revalidate
        form.validateField("slug");
      }
    } catch (err) {
      console.log("Slug API error:", err);
      setSlugStatus("");
      form.setFieldValue("slugStatus", "");
    }
  };

  const categoryListFnc = async () => {
    axios
      .post(`${url}/dropdown/blog-category`)
      .then((res) => {
        let newArr = res?.data?.data?.categories?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCategoriesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const initialValues = {
    id: params?.id,
    category_id: data?.category_id ?? "",
    title: data?.title ?? "",
    description: data?.description ?? "",
    meta_title: data?.meta_title ?? "",
    meta_description: data?.meta_description ?? "",
    landscape_card_image_1: data?.landscape_card_image_1 ?? "",
    landscape_card_image_1_alt_text:
      data?.landscape_card_image_1_alt_text ?? "",
    landscape_card_image_2: data?.landscape_card_image_2 ?? "",
    landscape_card_image_2_alt_text:
      data?.landscape_card_image_2_alt_text ?? "",
    portrait_card_image: data?.portrait_card_image ?? "",
    portrait_card_image_alt_text: data?.portrait_card_image_alt_text ?? "",
    blogs_details_image: data?.blogs_details_image ?? "",
    blogs_details_image_alt_text: data?.blogs_details_image_alt_text ?? "",
    author: data?.author ?? "",
    author_profile: data?.author_profile ?? "",
    author_profile_alt: data?.author_profile_alt ?? "",
    author_about: data?.author_about ?? "",
    author_social_media_link: data?.author_social_media_link ?? "",
    author_social_media_link_icon: data?.author_social_media_link_icon ?? "",
    status: data?.status ?? "draft",
    content_section: [],
    faq: [],
    slug: data?.slug ?? "",
    property_cards_tagging: [],
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    author: Yup.string().required("Required"),

    content_section: Yup.array()
      .min(
        1,
        "Content section cannot be empty. Please add at least one block in the editor.",
      )
      .required("Required"),

    // Landscape Image 1
    landscape_card_image_1_alt_text: Yup.string().test(
      "alt-text-required",
      "Alt text is required when an image is provided",
      function (value) {
        const { landscape_card_image_1 } = this.parent;
        // If image exists but alt text is missing/empty, fail validation
        if (landscape_card_image_1 && (!value || value.trim() === "")) {
          return false;
        }
        return true;
      },
    ),

    // Landscape Image 2
    landscape_card_image_2_alt_text: Yup.string().test(
      "alt-text-required",
      "Alt text is required when an image is provided",
      function (value) {
        const { landscape_card_image_2 } = this.parent;
        if (landscape_card_image_2 && (!value || value.trim() === "")) {
          return false;
        }
        return true;
      },
    ),

    // Portrait Image
    portrait_card_image_alt_text: Yup.string().test(
      "alt-text-required",
      "Alt text is required when an image is provided",
      function (value) {
        const { portrait_card_image } = this.parent;
        if (portrait_card_image && (!value || value.trim() === "")) {
          return false;
        }
        return true;
      },
    ),

    // Blog Details Image
    blogs_details_image_alt_text: Yup.string().test(
      "alt-text-required",
      "Alt text is required when an image is provided",
      function (value) {
        const { blogs_details_image } = this.parent;
        if (blogs_details_image && (!value || value.trim() === "")) {
          return false;
        }
        return true;
      },
    ),

    slug: Yup.string().test("slug-check", "Slug already exists", function () {
      return this.parent.slugStatus !== "exists";
    }),
  });

  const handleSubmit = (values) => {
    const payload = {
      where: {
        id: values.id,
      },
      values: {
        ...values,
      },
    };

    delete payload.values.id;

    payload.values.faq = faqs;
    payload.values.content_section = contentData;

    axios
      .post(`${url}/model/blogs/edit`, payload)
      .then((response) => {
        successToast(response.data.message);
        navigate(`/blogs/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    axios
      .post(`${url}/model/blogs/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setFaqs(res.data.data.faq);
        setContentData(res.data.data.content_section);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    categoryListFnc();
  }, []);

  if (loading) {
    return <p>loading</p>;
  }

  const statusList = [
    { label: "Draft", value: "draft" },
    { label: "Submitted", value: "submitted" },
    { label: "Approved", value: "approved" },
    { label: "Published", value: "published" },
  ];

  return (
    <MainLayout>
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />

      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, errors, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <div className="flex items-center gap-2">
                  <button onClick={() => navigate(-1)} type="button">
                    <img src={backArrow} alt="<" width={10} height={10} />
                  </button>
                  <h2 className="text-xl font-semibold capitalize">
                    Blogs - Edit
                  </h2>
                </div>

                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => navigate(-1)}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Save
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-5">
                  <FormDropDown
                    name={"category_id"}
                    label={"category_id"}
                    options={categoriesList}
                    value={categoriesList?.find(
                      (item) => item?.value === values?.category_id,
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"title"}
                    label={"title"}
                    placeholder={`Enter your title`}
                    maxLength={70}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"description"}
                    label={"Description"}
                    placeholder={`Enter description`}
                    maxLength={160}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"meta_title"}
                    label={"meta title"}
                    placeholder={`Enter your title`}
                    maxLength={70}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"meta_description"}
                    label={"meta Description"}
                    placeholder={`Enter meta description`}
                    maxLength={160}
                  />
                </div>
                <div className="my-5">
                  <FormDocumentField
                    name={"landscape_card_image_1"}
                    label={"Landscape card image 1"}
                  />
                </div>{" "}
                <div className="my-4">
                  <FormTextField
                    name={"landscape_card_image_1_alt_text"}
                    label={"landscape card image 1 alt text"}
                    placeholder={`Enter landscape card image 1 alt text`}
                  />
                </div>{" "}
                <div className="my-5">
                  <FormDocumentField
                    name={"landscape_card_image_2"}
                    label={"Landscape card image 2"}
                  />
                </div>{" "}
                <div className="my-4">
                  <FormTextField
                    name={"landscape_card_image_2_alt_text"}
                    label={"landscape card image 2 alt text"}
                    placeholder={`Enter landscape card image 2 alt text`}
                  />
                </div>
                <div className="my-5">
                  <FormDocumentField
                    name={"portrait_card_image"}
                    label={"portrait card image"}
                  />
                </div>{" "}
                <div className="my-4">
                  <FormTextField
                    name={"portrait_card_image_alt_text"}
                    label={"portrait_card_image_alt_text"}
                    placeholder={`Enter portrait_card_image_alt_text`}
                  />
                </div>
                <div className="my-5">
                  <FormDocumentField
                    name={"blogs_details_image"}
                    label={"blogs_details_image"}
                  />
                </div>{" "}
                <div className="my-4">
                  <FormTextField
                    name={"blogs_details_image_alt_text"}
                    label={"blogs_details_image_alt_text"}
                    placeholder={`Enter blogs_details_image_alt_text`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"author"}
                    label={"author"}
                    placeholder={`Enter your author`}
                  />
                </div>
                <div className="my-4">
                  <FormImageField
                    name={"author_profile"}
                    label={"author profile picture"}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"author_profile_alt"}
                    label={"author profile alt"}
                    placeholder={`Enter author profile alt`}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"author_about"}
                    label={"author about"}
                    placeholder={`Enter about`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"author_social_media_link"}
                    label={"author social media link"}
                    placeholder={`Enter social media link`}
                  />
                </div>
                <div className="my-4">
                  <FormImageField
                    name={"author_social_media_link_icon"}
                    label={"author social media link icon"}
                  />
                </div>
                <div className="my-4">
                  <FormSlugTextField
                    name={"slug"}
                    label={"slug"}
                    placeholder={`Enter your slug`}
                    slugValue={data?.slug}
                    checkSlugApi={checkSlugApi}
                    slugStatus={slugStatus}
                    setSlugStatus={setSlugStatus}
                  />
                </div>
                <div className="my-5">
                  <FormDropDown
                    name={"status"}
                    label={"status"}
                    options={statusList}
                    value={statusList?.find(
                      (item) => item?.value === values?.status,
                    )}
                  />
                </div>
              </section>
              <div className="w-full overflow-y-auto">
                {errors.content_section && (
                  <p className="text-errorColor text-sm mt-1">
                    {errors.content_section}
                  </p>
                )}
                <Editor
                  contentData={contentData}
                  setContentData={(data) => {
                    setContentData(data);
                    setFieldValue("content_section", data);
                  }}
                />
              </div>

              <div className="w-full overflow-y-auto">
                <FAQManager faqs={faqs} onChange={setFaqs} />
              </div>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditBlogs;
